import { Minus, Plus } from "lucide-react";
import React, { useEffect, useState } from "react";
import { CustomCheckbox, ToggleButton } from "../../common/GeneralComponent";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { fetchData } from "../../../utils/functions";

const Permissions = ({
  selectedGroup,
  selectedPermissions,
  setSelectedPermissions,
}) => {
  const [permissions, setPermissions] = useState([]);
  const [isFiltersVisible, setIsFiltersVisible] = useState(true);
  const [isAllChecked, setIsAllChecked] = useState(false);
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!selectedGroup && !selectedGroup?.id) {
        setPermissions([]);
        setSelectedPermissions([]);
        setIsAllChecked(false);
        return;
      }

      const groupId = selectedGroup?.id || selectedGroup;

      try {
        const response = await fetchData(`role/${groupId}/permissions`, "GET");
        let perms = response?.data || [];
        perms = Array.from(new Map(perms.map((p) => [p.id, p])).values());
        perms = perms.sort((a, b) => a.id - b.id);
        setPermissions(perms);
        const allSelected =
          perms.length > 0 &&
          perms.every((p) => selectedPermissions.includes(p.id));
        setIsAllChecked(allSelected);
      } catch (error) {
        console.error("Error fetching permissions:", error);
        setPermissions([]);
        setSelectedPermissions([]);
        setIsAllChecked(false);
      }
    };

    fetchPermissions();
  }, [selectedGroup]);
useEffect(() => {
  if (permissions.length === 0) {
    setIsAllChecked(false);
    return;
  }
  const allSelected = permissions.every((p) =>
    selectedPermissions.includes(p.id)
  );

  setIsAllChecked(allSelected);
}, [selectedPermissions, permissions]);


  const toggleFilters = () => setIsFiltersVisible((prev) => !prev);

  const handleCheckboxChange = (id) => {
    setSelectedPermissions((prev) =>
      prev.includes(id) ? prev.filter((permId) => permId !== id) : [...prev, id]
    );
  };

  const handleToggleAll = (newState) => {
    if (newState) {
      setSelectedPermissions(permissions.map((perm) => perm.id));
    } else {
      setSelectedPermissions([]);
    }
    setIsAllChecked(newState);
  };

  const handleToggleGroup = (groupPerms, newState) => {
    const groupIds = groupPerms.map((p) => p.id);
    setSelectedPermissions((prev) => {
      if (newState) {
        return [...new Set([...prev, ...groupIds])];
      } else {
        return prev.filter((id) => !groupIds.includes(id));
      }
    });
  };
  const groupedByMainGroup = permissions.reduce((acc, perm) => {
    const groupName =
      perm.permission_group?.trim()?.toLowerCase().replace(/\s+/g, " ") ||
      "other";

    if (!acc[groupName]) acc[groupName] = [];
    acc[groupName].push(perm);
    return acc;
  }, {});

  const groupSubSections = (groupPerms, groupName) => {
    const lower = groupName.toLowerCase();
    const splitGroups = [
      "household",
      "wash",
      "school assessment",
      "health facility assessment",
      "grants",
    ];

    if (!splitGroups.includes(lower)) {
      return { [groupName]: groupPerms };
    }

    return groupPerms.reduce((acc, perm) => {
      let name = perm.permission_name.toLowerCase();

      const isMain = [
        `${lower.replace(/\s+/g, "-")}-view`,
        `${lower.replace(/\s+/g, "-")}-create`,
        `${lower.replace(/\s+/g, "-")}-update`,
        `${lower.replace(/\s+/g, "-")}-delete`,
        `${lower.replace(/\s+/g, "-")}-approve`,
        `${lower.replace(/\s+/g, "-")}-reject`,
      ].some((x) => name === x);

      if (isMain) {
        if (!acc["main"]) acc["main"] = [];
        acc["main"].push(perm);
        return acc;
      }

      const base = lower.replace(/ /g, "-");
      const subKey = name.replace(`${base}-`, "").split("-")[0];
      if (!acc[subKey]) acc[subKey] = [];
      acc[subKey].push(perm);
      return acc;
    }, {});
  };

  const cleanPermissionName = (name) => {
    if (!name) return "";
    return name.replace(/^[-_]+|[-_]+$/g, "");
  };


// const ToggleButton = ({ isChecked, onToggle }) => {
//   return (
//     <div
//       onClick={() => onToggle(!isChecked)}
//       role="switch"
//       aria-pressed={isChecked}
//       className="flex items-center gap-2 cursor-pointer"
//     >
//       <div
//         className={`w-9 h-4 flex items-center rounded-full p-[2px] transition-colors duration-300 border bg-lightGray border-muted`}
//       >
//         <div
//           className={`h-3 w-3 rounded-full bg-primaryDark shadow-md transform transition-transform duration-300 ${
//             isChecked ? "translate-x-[1.1rem]" : "translate-x-0"
//           }`}
//         ></div>
//       </div>
//       <p className="text-[0.75rem]">
//         {isAllChecked ? "Uncheck All" : "Check All"}
//       </p>
//     </div>
//   );
// };

  
const ToggleButton = ({ isChecked, onToggle }) => {
  return (
    <div
      onClick={() => onToggle(!isChecked)}
      role="switch"
      aria-pressed={isChecked}
      className="flex items-center gap-2 cursor-pointer"
    >
      <div className="w-9 h-4 flex items-center rounded-full p-[2px] transition-colors duration-300 border bg-lightGray border-muted">
        <div
          className={`h-3 w-3 rounded-full bg-primaryDark shadow-md transform transition-transform duration-300 ${
            isChecked ? "translate-x-[1.1rem]" : "translate-x-0"
          }`}
        ></div>
      </div>
      <p className="text-[0.75rem] ">
        {isChecked ? "Uncheck All" : "Check All"}
      </p>
    </div>
  );
};

  return (
    <div className="w-full py-4">
      <div>
        <p className="text-muted">Mark permissions to assign to the role.</p>
        <div className="flex gap-6 mt-4">
          <div className="flex items-center gap-1">
            <ToggleButton isChecked={isAllChecked} onToggle={handleToggleAll} />
            <p className="text-[0.75rem] text-white">
              {isAllChecked ? "Uncheck All" : "Check All"}
            </p>
          </div>
        </div>
      </div>

      <Accordion sx={{ margin: "10px 0" }} expanded={isFiltersVisible}>
        <AccordionSummary
          expandIcon={
            isFiltersVisible ? (
              <Minus color="#fff" size={14} />
            ) : (
              <Plus color="#fff" size={14} />
            )
          }
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ backgroundColor: "#137e81", color: "#fff" }}
          onClick={toggleFilters}
        >
          Permissions
        </AccordionSummary>

        <AccordionDetails>
          {permissions.length === 0 ? (
            <p className="text-sm text-gray-500">
              No permissions assigned to this group
            </p>
          ) : (
            <div className="space-y-6">
              {Object.entries(groupedByMainGroup).map(
                ([groupName, groupPerms]) => {
                  const subSections = groupSubSections(groupPerms, groupName);
                  const displayGroupName =
                    groupName.charAt(0).toUpperCase() + groupName.slice(1);

                  return (
                    <div key={groupName}>
                      <div className="flex items-center gap-3 mb-2 mt-5">
                        <label className="font-semibold text-gray-700 uppercase">
                          {displayGroupName}
                        </label>
                      </div>

                      {Object.entries(subSections).map(
                        ([subName, subPerms]) => {
                          const allChecked = subPerms.every((p) =>
                            selectedPermissions.includes(p.id)
                          );
                          const formattedSubName = subName
                            .replace(/^[-_\s]+|[-_\s]+$/g, "")
                            .replace(/[-_]+/g, " ")
                            .replace(/\s+/g, " ")
                            .trim()
                            .replace(/\b\w/g, (c) => c.toUpperCase());

                          const displayName =
                            subName === "main" ||
                            formattedSubName.toLowerCase() ===
                              displayGroupName.toLowerCase()
                              ? displayGroupName
                              : `${displayGroupName} - ${formattedSubName}`;

                          return (
                            <div
                              key={subName}
                              className="border border-gray-200 rounded-lg p-4"
                            >
                              <div className="flex items-center gap-3">
                                <ToggleButton
                                  isChecked={allChecked}
                                  onToggle={(state) =>
                                    handleToggleGroup(subPerms, state)
                                  }
                                />
                                <label className="font-medium capitalize">
                                  {displayName}
                                </label>
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-6 lg:grid-cols-6 gap-x-6 gap-y-3 mt-2">
                                {subPerms.map((perm) => (
                                  <CustomCheckbox
                                    key={perm.id}
                                    label={cleanPermissionName(
                                      perm.permission_name
                                    )}
                                    checked={selectedPermissions.includes(
                                      perm.id
                                    )}
                                    onChange={() =>
                                      handleCheckboxChange(perm.id)
                                    }
                                  />
                                ))}
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                  );
                }
              )}
            </div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Permissions;
